import { render, staticRenderFns } from "./ModifySaleTagModal.vue?vue&type=template&id=3a77d338&scoped=true&"
import script from "./ModifySaleTagModal.vue?vue&type=script&lang=js&"
export * from "./ModifySaleTagModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a77d338",
  null
  
)

export default component.exports